import { useHistory, useLocation } from "react-router";
import { BookmarkUtils } from "utilities/bookmark-utils";
import useMyLiNKDefaults from "utilities/hooks/domain/my-link/use-my-link-defaults";
import { RouteUtils } from "utilities/route-utils";

const useSortBookmarkCounts = (paramIdToAppend?: string | number) => {
    const { pathname, search } = useLocation();
    const { replace } = useHistory();

    const {
        getBookmarkSortUserSettingForGrouping,
        setBookmarkSortUserSettingForGrouping,
    } = useMyLiNKDefaults();

    const groupId = BookmarkUtils.getGroupingByPath();

    const defaultSort = getBookmarkSortUserSettingForGrouping(groupId);

    const sortByKey = paramIdToAppend ? `sortBy_${paramIdToAppend}` : "sortBy";

    const { [sortByKey]: sortBy = defaultSort } =
        RouteUtils.queryStringToObject<{ [sortByKey]: number }>(search);

    const onSortByChange = async (newVal) => {
        const { [sortByKey]: oldSortBy, ...otherParams } =
            RouteUtils.queryStringToObject<{
                [key: string]: any;
            }>(search);
        await setBookmarkSortUserSettingForGrouping(
            newVal,
            groupId ? Number(groupId) : undefined
        );
        replace(
            RouteUtils.appendQueryParams(pathname, {
                ...otherParams,
                [sortByKey]: newVal,
            })
        );
    };

    return {
        sortBy,
        onSortByChange,
        sortByKey,
    };
};

export default useSortBookmarkCounts;
